
import React from 'react';
import { Answer } from '@/types/assessment';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Plus, List } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface StandardAnswersProps {
  categoryId: string;
  questionId: string;
  answers: Answer[];
  onAddAnswer: (categoryId: string, questionId: string) => void;
  onUpdateAnswer: (categoryId: string, questionId: string, answerId: string, updates: Partial<Answer>) => void;
  onOpenRecommendations: (answerId: string) => void;
}

export function StandardAnswers({ 
  categoryId, 
  questionId, 
  answers, 
  onAddAnswer, 
  onUpdateAnswer,
  onOpenRecommendations
}: StandardAnswersProps) {
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <Label>Answer Options</Label>
        <Button 
          variant="outline" 
          size="sm" 
          onClick={() => onAddAnswer(categoryId, questionId)}
        >
          <Plus className="h-3 w-3 mr-1" /> Add Option
        </Button>
      </div>
      
      {answers.map((answer) => (
        <div key={answer.id} className="flex items-center gap-3">
          <div className="flex-1">
            <Input
              value={answer.text}
              onChange={(e) => onUpdateAnswer(
                categoryId, 
                questionId, 
                answer.id, 
                { text: e.target.value }
              )}
              placeholder="Answer text"
            />
          </div>
          <div className="w-20">
            <Input
              type="number"
              value={answer.value}
              onChange={(e) => onUpdateAnswer(
                categoryId, 
                questionId, 
                answer.id, 
                { value: Number(e.target.value) }
              )}
              placeholder="Value"
              min="0"
              max="10"
            />
          </div>
          <div>
            <Button 
              variant="ghost" 
              size="sm" 
              onClick={() => onOpenRecommendations(answer.id)}
              className="flex items-center gap-1 min-w-[60px] justify-center"
              title="Manage recommendations"
            >
              <List className="h-4 w-4" />
              <Badge variant="outline" className="text-xs ml-1 bg-gray-100">
                {answer.recommendedActions?.length || 0}
              </Badge>
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
}
